/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_FindInputs */

const en_directory_nav_find = /** @type {(inputs: Directory_Nav_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tools, e.g. 'coding assistant'...`)
};

const zh_directory_nav_find = /** @type {(inputs: Directory_Nav_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 AI 工具与场景，例如「视频生成 / 编程助手 / PPT / 写作」…`)
};

/**
* | output |
* | --- |
* | "Search tools, e.g. 'coding assistant'..." |
*
* @param {Directory_Nav_FindInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_find = /** @type {((inputs?: Directory_Nav_FindInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_FindInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_find(inputs)
	return zh_directory_nav_find(inputs)
});
export { directory_nav_find as "directory.nav.find" }